import * as UriJS from 'uri-js'

export const parseImageUrl = (s: string): string =>
  s == undefined || s == null
    ? ''
    : `/drupal/media${UriJS.parse(s).path}${UriJS.parse(s).query ? '?' + UriJS.parse(s).query : ''}`
